"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuccessScene = void 0;
const react_1 = __importDefault(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_i18next_1 = require("react-i18next");
const config_1 = require("../config");
const routes_1 = require("../routes");
const AuthLayout_1 = require("./AuthLayout/AuthLayout");
exports.SuccessScene = ({ context, subTitle }) => {
    const { t } = react_i18next_1.useTranslation(context);
    const mobileSupportOnly = config_1.getReleoxOption('mobileSupportOnly');
    const links = [];
    if (!mobileSupportOnly) {
        links.push({
            to: routes_1.routes.LOGIN,
            id: 'login-link',
            text: t('toLogin'),
        });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, `${t('title')}`)),
        react_1.default.createElement(AuthLayout_1.AuthLayout, { title: t('title'), subTitle: subTitle || t('subTitle'), context: context, links: links })));
};
//# sourceMappingURL=SuccessScene.js.map